<template>
  <base-section id="pro-features">
    <!-- <v-img
      :src="require('@/assets/logo.png')"
      class="mx-auto mb-8"
      max-width="128"
    /> -->

    <base-section-heading title="Our Notable Features">
      <!-- Our comprehensive solution covers almost every need Get the PRO version of <strong>Zero</strong> and level up your theme<br />with
      additional components, pages, and Free updates. -->
    </base-section-heading>

    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" md="7">
          <v-simple-table>
            <thead>
              <tr>
                <th />
                <th class="body-1 font-weight-bold text-center">
                  Feature Present
                </th>
                <!-- <th class="body-1 font-weight-bold text-center">
                  What's in the PRO version?
                </th> -->
              </tr>
            </thead>

            <tbody class="body-1">
              <tr v-for="([name, one, two], i) in features" :key="i">
                <td v-text="name" />

                <td class="text-center font-weight-bold">
                  <template v-if="typeof one === 'boolean'">
                    <v-icon :color="one ? 'success' : 'error'">
                      mdi-{{ one ? "check" : "close" }}
                    </v-icon>
                  </template>

                  <template v-else>
                    {{ one }}
                  </template>
                </td>

                <!-- <td class="text-center font-weight-bold">
                  <template v-if="typeof two === 'boolean'">
                    <v-icon :color="two ? 'success' : 'error'">
                      mdi-{{ two ? "check" : "close" }}
                    </v-icon>
                  </template>

                  <template v-else>
                    {{ two }}
                  </template>
                </td> -->
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>

        <v-col cols="12" md="5">
          <v-card elevation="16" class="mb-12">
            <base-img max-width="100%" :src="require('@/assets/market.jpg')" />
          </v-card>

          <div class="text-center">
            <base-btn :tile="false" color="primary" :to="'/signup'" rounded>
              Sign Up Now

              <v-icon right>
                mdi-rocket
              </v-icon>
            </base-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
export default {
  name: "SectionProChart",

  data: () => ({
    features: [
      ["Multi Client Support", true, "40+"],
      ["Multi Vendor Support", true, 10],
      ["Local Lanuage Support", true, true],
      ["Driver App", true, true],
      ["Client App", true, true],
      ["Real Time Tracking", true, true],
      ["Automated Invoicing", true, true],
      ["Automated Load Matching", true, true],
      ["Network Transport Sourcing Real Time", true, true],
      ["Reverse Auction Option", true, true],
      // ["Price", "Free", "$60"],
    ],
  }),
};
</script>
